import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

export const CGVPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="sticky top-0 z-50 bg-[#09090b]/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-zinc-400 hover:text-white transition">
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo-youmi.png" alt="YOUMI GREEN VTC" className="w-10 h-10" />
            <span className="text-lg font-bold text-white font-['Outfit']">YOUMI <span className="text-emerald-500">GREEN</span></span>
          </button>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white font-['Outfit'] mb-8" data-testid="cgv-title">Conditions Générales de Vente</h1>
        
        <div className="space-y-8 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 1 — Objet</h2>
            <p>
              Les présentes CGV s'appliquent à toutes les prestations de transport privé (VTC) proposées par 
              <strong className="text-white"> YOUMI GREEN VTC</strong>, SASU, SIRET 889 633 020 00017, 
              1 rue du Bel Air, 91000 Évry-Courcouronnes, à tout client ayant effectué une réservation via le 
              site youmigreenvtc.com, par email ou WhatsApp.
            </p>
            <p className="mt-2">Toute réservation implique l'acceptation pleine et entière des présentes CGV.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 2 — Prestations</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Transferts aéroport Nice Côte d'Azur</li>
              <li>Courses urbaines et interurbaines sur la Côte d'Azur et le Var</li>
              <li>Navettes Nice-Cannes-Monaco-Saint-Tropez</li>
              <li>Mise à disposition horaire</li>
              <li>Transport longue distance</li>
              <li>Solutions entreprises</li>
            </ul>
            <p className="mt-2">
              Prestations assurées en <strong className="text-white">Tesla Model Y 100% électrique</strong> par 
              un chauffeur professionnel certifié.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 3 — Réservation</h2>
            <p>
              Toute réservation doit être effectuée au minimum <strong className="text-white">5 heures à l'avance</strong>. 
              Elle est confirmée après réception d'une confirmation écrite par email ou WhatsApp. Le client s'engage 
              à fournir des informations exactes : adresse de départ, destination, date, heure, nombre de passagers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 4 — Tarifs et paiement</h2>
            <p>
              Les tarifs sont ceux indiqués sur le site au moment de la réservation, en euros TTC.
            </p>
            <p className="mt-2"><strong className="text-white">Paiement accepté :</strong> en ligne sécurisé, virement bancaire, espèces à bord sur accord préalable.</p>
            <p className="mt-2">
              Réduction de 10% pour paiement en ligne (code <strong className="text-emerald-400">FIRST10</strong> pour 
              la première réservation). Facturation mensuelle disponible pour les entreprises.
            </p>
            <p className="mt-2 text-amber-300/90 text-sm">
              <strong className="text-amber-400">Variabilité saisonnière :</strong> les prix affichés sur le site
              (notamment les transferts aéroport) peuvent être ajustés à la hausse pendant les périodes de haute
              affluence et événements spéciaux (Festival de Cannes, Grand Prix de Monaco, Noël, Nouvel An, etc.)
              pour les clients non privilégiés.
            </p>
          </section>

          <section data-testid="cgv-privilege-section">
            <h2 className="text-xl font-semibold text-white mb-3">Article 4 bis — Programme Client Privilège</h2>
            <p>
              YOUMI GREEN VTC propose un statut <strong className="text-amber-400">« Client Privilège »</strong>{' '}
              accordé aux clients inscrits ayant effectué un minimum de <strong className="text-white">10 courses
              sur les 6 derniers mois glissants</strong>.
            </p>
            <p className="mt-2"><strong className="text-white">Avantages du statut Client Privilège :</strong></p>
            <ul className="list-disc list-inside space-y-1 mt-1">
              <li>Prix fixes et garantis toute l'année, sans majoration saisonnière ni événementielle</li>
              <li>Accès aux tarifs préférentiels affichés sur le site (incluant les transferts aéroport)</li>
              <li>Accès prioritaire à tous les avantages exclusifs fournis par YOUMI GREEN VTC</li>
              <li>Conservation à vie du statut tant que le compte client reste actif</li>
            </ul>
            <p className="mt-2">
              Le statut est accordé automatiquement après vérification du nombre de courses effectuées et reste
              valable à vie. YOUMI GREEN VTC se réserve le droit de suspendre ou retirer ce statut en cas de
              comportement frauduleux, d'impayés, ou de manquement aux présentes CGV.
            </p>
            <p className="mt-2 text-zinc-400 text-sm">
              Les conditions de tarification client privilège ne sont pas cumulables avec d'autres offres
              promotionnelles, sauf mention contraire explicite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 5 — Annulation</h2>
            <ul className="space-y-2">
              <li><strong className="text-white">Plus de 24h avant la course :</strong> remboursement intégral.</li>
              <li><strong className="text-white">Entre 12h et 24h avant :</strong> 50% retenu.</li>
              <li><strong className="text-white">Moins de 12h ou no-show :</strong> 100% dû.</li>
            </ul>
            <p className="mt-2">
              Pour les transferts aéroport : 30 minutes d'attente gratuite après atterrissage réel, puis 0,35€/minute.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 6 — Obligations du client</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Être à l'heure au lieu convenu</li>
              <li>Porter la ceinture de sécurité</li>
              <li>Ne pas fumer, consommer d'alcool ou substances illicites dans le véhicule</li>
              <li>Tout dommage causé au véhicule sera facturé au client</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 7 — Responsabilité</h2>
            <p>
              YOUMI GREEN VTC s'engage à réaliser les prestations avec diligence. Sa responsabilité ne peut être 
              engagée en cas de force majeure, conditions météo exceptionnelles, embouteillages imprévisibles ou 
              événements indépendants de sa volonté.
            </p>
            <p className="mt-2">
              La société est couverte par une assurance responsabilité civile professionnelle transport de personnes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Article 8 — Litiges</h2>
            <p>
              En cas de litige, contacter <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a>. 
              Sans résolution amiable sous 30 jours, recours possible à la médiation de la consommation. 
              Droit français applicable.
            </p>
          </section>

          <p className="text-zinc-500 text-sm pt-4 border-t border-zinc-800">Dernière mise à jour : 15 mars 2026</p>
        </div>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/mentions-legales" className="text-emerald-400 hover:underline">Mentions légales</Link>
          <Link to="/confidentialite" className="text-emerald-400 hover:underline">Politique de confidentialité</Link>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
